module.exports = __webpack_public_path__ + "img/LCRG_Swords_06.9960a3d6.png";